module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "content-chapter",
    attrs: {
      "id": "_idParaDest-3",
      "xml:lang": "en-GB"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/97816425039443#_idTextAnchor000"
    }
  }, [_c('span', {
    staticClass: "yellow"
  }, [_vm._v("A Letter to Readers"), _c('span', {
    attrs: {
      "id": "_idTextAnchor055"
    }
  })])])]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph-white"
  }, [_vm._v("I’ve been a quote collector since I was fourteen. In fact, I still have the same notebook, started in my teen years, that I used to record words that moved me. At an early age, I sought out quotes about “making the most of your day.” I also liked short quotes that became affirmations for living. These affirmations have remained a powerful force in my life, and you’ll find many of them throughout this book.")]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph-white"
  }, [_vm._v("Sadly, I also gravitated to quotes on grieving because my dear mother died when I was eleven and my maternal grandfather died when I was seventeen. I no longer had these two incredible people acting as guides in my life, so I turned to others’ words to help me along. Hundreds of times, if not thousands, I found solace from four lines in Wordsworth’s “Ode on Intimations of Immortality from Recollections of Early Childhood”:")]), _vm._v(" "), _c('p', {
    staticClass: "Yellow_Quote"
  }, [_vm._v("Though nothing can bring back the hour"), _c('br'), _vm._v("Of splendour in the grass, of glory in the flower;"), _c('br'), _vm._v("We will grieve not, rather find"), _c('br'), _vm._v("Strength in what remains"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("behind"), _c('span', {
    staticClass: "CharOverride-14"
  }, [_vm._v("…")])]), _vm._v(" "), _c('p', {
    staticClass: "QuoteAuthor_Yellow"
  }, [_vm._v("—William Wordsworth")]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph-white"
  }, [_vm._v("I continued collecting and curating quotes as I entered adulthood. During my college years, I loved finding quotes about both appreciating life and achievement. The following quote by Carlos Castaneda became popular when I was in college. It came from his 1968 book,"), _c('span', {
    staticClass: "BookItalic _idGenCharOverride-1"
  }), _c('span', {
    staticClass: "BROTHERregularitalic"
  }, [_vm._v("The Teachings of Don Juan: A Yaqui Way of Knowledge.")])]), _vm._v(" "), _c('p', {
    staticClass: "Yellow_Quote"
  }, [_vm._v("For me there is only the traveling on paths that have heart, on any path that may have heart, and the only worthwhile challenge is to traverse its full length—and there I travel looking, looking"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("breathlessly.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteAuthor_Yellow"
  }, [_vm._v("—Carlos Castaneda")]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph-white"
  }, [_vm._v("At the start of my full-time work life when I was twenty-two, I was drawn to quotes about passion and success, and general quotes about life. Here is one I wrote out, pasted a pretty picture above, and put on my office wall.")]), _vm._v(" "), _c('p', {
    staticClass: "Yellow_Quote"
  }, [_vm._v("No longer forward or behind"), _c('br'), _vm._v("I look in hope or fear;"), _c('br'), _vm._v("But, grateful, take the good I find,"), _c('br'), _vm._v("The best of now and"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("here.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteAuthor_Yellow"
  }, [_vm._v("—John Greenleaf Whittier")]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph-white"
  }, [_vm._v("When I became a mother, my priorities changed so much that finding inspirational quotes about children, parenthood, family, and motherhood helped me navigate this new path. When my kids were still under the age of five, I stood in front of my refrigerator countless times to read this magnet:")]), _vm._v(" "), _c('p', {
    staticClass: "Yellow_Quote"
  }, [_vm._v("Cleaning your house while your kids are still growing"), _c('br'), _vm._v("is like shoveling the walk before it stops"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("snowing.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteAuthor_Yellow _idGenParaOverride-1"
  }, [_vm._v("—Phyllis Diller")]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph-white"
  }, [_vm._v("If inspiration didn’t help me then as a young mother, at least I was comforted with humor. While humor can be a powerful healer, we often need more than just amusement along our journey in life. I went through a divorce mid-life and found I needed quotes on challenges, comfort, courage, faith, forgiveness, grieving (again), hope, perspective, reflections, renewal, and wisdom. It has been a labor of love as I’ve collected quotes that reflect upon all of these topics, which you’ll find in"), _c('span', {
    staticClass: "BROTHERregularitalic"
  }, [_vm._v(" Hey! It’s Your Day")]), _vm._v(". Here’s one from the “Comfort” section:")]), _vm._v(" "), _c('p', {
    staticClass: "Yellow_Quote"
  }, [_vm._v("The human spirit is stronger than anything"), _c('br'), _vm._v("that can happen to"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("it.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteAuthor_Yellow"
  }, [_vm._v("—C. C. Scott")]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph-white"
  }, [_vm._v("Now, I’ve been happily married for over twenty-five years to my high school sweetheart, and I’m the mother of two grown children and the grandmother of four. The topics of aging, children, family, gratitude, inspiration, kindness, perspective, reflections, simplicity, and simple reminders have become especially meaningful to me. I want to make the most of every day, and two “author unknown” quotes offer the daily perspective I seek:")]), _vm._v(" "), _c('p', {
    staticClass: "Yellow_Quote"
  }, [_vm._v("What a wonderful thought it is"), _c('br'), _vm._v("that some of the best days of our lives"), _c('br'), _vm._v("haven’t happened"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("yet.")]), _vm._v(" "), _c('p', {
    staticClass: "Yellow_Quote"
  }, [_c('span', {
    staticClass: "CharOverride-15"
  }, [_vm._v("And…")])]), _vm._v(" "), _c('p', {
    staticClass: "Yellow_Quote"
  }, [_vm._v("Do not regret growing older."), _c('br'), _vm._v("It’s a privilege denied to"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("many.")]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph-white"
  }, [_vm._v("When I was close to completing this book, I realized I had forgotten to include a section about pets! If it had not been for my dogs and cats through the years, I don’t know how I would have gotten through many challenges and long periods of grief. So, in honor of our dear pets:")]), _vm._v(" "), _c('p', {
    staticClass: "Yellow_Quote"
  }, [_vm._v("Sometimes you don’t need words to feel better;"), _c('br'), _vm._v("you just need the nearness of your"), _c('span', {
    staticClass: "noBreak"
  }), _vm._v("dog.")]), _vm._v(" "), _c('p', {
    staticClass: "QuoteAuthor_Yellow"
  }, [_vm._v("—Natalie Lloyd")]), _vm._v(" "), _c('p', {
    staticClass: "body-paragraph-white"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cfd982e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/97816425039445.vue
// module id = 75
// module chunks = 0